<template>
  <div v-editable="blok" class="team-member">
    <div class="wrapper" v-bind:style="'max-width: ' + blok.maxwidth + 'px'">
        <img :src="blok.image"/>
    </div>
    <h1>{{ blok.name }}</h1>
    <h2>{{blok.job}}</h2>
  </div>
</template>

<script>
export default {
  props: ['blok'],
  data () {
    return {
      maxw: 0
    }
  },
  mounted(){
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Team.vue